module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=PM - Saint Pierre and Miquelon.02212d94.svg";